import createIcon from '../../createIcon';

/**
 * @component @name AirlineStops
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNzEgOS4yMUMxNi40MyAxMC43OCAxMy45NSAxMy4zIDEzLjUgMTdIMTUuNVYxOUg5LjVWMTdIMTEuNUMxMSAxMi41IDcuMTMgOSAyLjUgOVY3QzYuODkgNyAxMC43MiA5LjU1IDEyLjUgMTMuM0MxMy42MyAxMC44NyAxNS40OSA5LjA1IDE3LjI4IDcuNzhMMTQuNSA1SDIxLjVWMTJMMTguNzEgOS4yMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AirlineStops = createIcon('AirlineStops', [
  [
    'path',
    {
      d: 'M18.71 9.21C16.43 10.78 13.95 13.3 13.5 17H15.5V19H9.5V17H11.5C11 12.5 7.13 9 2.5 9V7C6.89 7 10.72 9.55 12.5 13.3C13.63 10.87 15.49 9.05 17.28 7.78L14.5 5H21.5V12L18.71 9.21Z',
      key: 'zs01no',
    },
  ],
]);

export default AirlineStops;
